module.exports = __webpack_public_path__ + "img/student_help_overview.01f3f601.jpg";